import { render, staticRenderFns } from "./StandardLearnerFees.vue?vue&type=template&id=42332c80&scoped=true&"
import script from "./StandardLearnerFees.vue?vue&type=script&lang=js&"
export * from "./StandardLearnerFees.vue?vue&type=script&lang=js&"
import style0 from "./StandardLearnerFees.vue?vue&type=style&index=0&id=42332c80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42332c80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VOverlay,VProgressCircular})
